import React from 'react';
import MaterialTable from "material-table"
import { calculateHeight } from '../../common/services/util';
import { getColorState } from '../services/config';
import TableTitle from 'common/components/TableTitle';


const TablePublicStock = ({ columns, loading, data }) => {
    return (
        <div className= "stateful-table">
            <MaterialTable
                title={<TableTitle>Stock público</TableTitle>}
                actions={[
                    {
                        icon: '',
                        isFreeAction: true,
                        disabled: true
                    }
                ]}
                columns={columns}
                isLoading={loading}
                data={data}
                options={{
                    sorting: true,
                    filtering: true,
                    search: false,
                    pageSize: 50,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    maxBodyHeight: calculateHeight(),
                    rowStyle: rowData => ({
                        backgroundColor: getColorState(rowData)
                    })
                }}
            />
        </div>
    )
}

export default TablePublicStock